export default Object.freeze({
    STEP_3_BANNER:     '1866559863',
    STEP_7_BANNER:     '3240185433',
    LIST_BANNER:       '9946663193',
    HOME_RIGHT_BANNER: '4684294894',
    ARCHIVE_BANNER:    '3245523471',
});
